import {inject, Injectable, Injector} from '@angular/core';
import {ActivatedRouteSnapshot, BaseRouteReuseStrategy, Router} from '@angular/router';

/** Navigation state asking for a new instance of the destination page, even when it is already on screen. */
export const FRESH_NAVIGATION = {fresh: true}

/**
 * Pages read their deep link once, from the snapshot (`?card=`, `?extraction=`, even `:workflowId`). A
 * navigation Angular resolves by reusing the page on screen therefore changes the URL and nothing else.
 * A navigation carrying FRESH_NAVIGATION rebuilds the leaf page instead; the shell and every parent stay.
 */
@Injectable()
export class FreshRouteReuseStrategy extends BaseRouteReuseStrategy {
  // Resolved lazily: the Router injects this strategy, so injecting the Router up front is a cycle.
  private injector = inject(Injector)

  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    const fresh = !future.firstChild && this.injector.get(Router).currentNavigation()?.extras.state?.['fresh']
    return !fresh && super.shouldReuseRoute(future, curr)
  }
}
